import {
  DailyControlPointDate,
  DailyControlPointId,
  DailyInspectionDate,
  DailyInspectionId,
  DailyPunchListDate,
  DailyPunchListId,
} from '../../filenameTemplateItems/instances/dailyInspection'
import {
  controlPoints,
  inspections,
  punchLists,
} from '../../filenameTemplateItems/instances/groups'
import { DailyInspectionReportItem } from '../classes/dailyInspection'

export const ControlPoint = new DailyInspectionReportItem({
  id: '964DB9E3-DE26-493F-89D6-C05D23F8679D',
  name: 'Control Point',
  classType: 'DailyInspectionControlPoint',
  classTypeName: 'Control Point',
  endpoint: 'controlPoints',
  queryParameter: 'control-point',
  label: 'controlPointId',
  sampleFilename: 'control-point',
  afterShortName: [
    { type: 'custom', text: '_CONTROL-POINT_' },
    { type: 'templateItem', templateItemId: DailyControlPointDate.id },
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: DailyControlPointId.id },
  ],
  additionalCompatibleTemplateItems: controlPoints,
})

export const Inspection = new DailyInspectionReportItem({
  id: '3D9E1F67-BE19-4001-AEED-303C4592128E',
  name: 'Inspection',
  classType: 'DailyInspectionInspection',
  classTypeName: 'Inspection',
  endpoint: 'inspections',
  queryParameter: 'inspection',
  label: 'inspectionId',
  sampleFilename: 'inspection',
  afterShortName: [
    { type: 'custom', text: '_INSPECTION_' },
    { type: 'templateItem', templateItemId: DailyInspectionDate.id },
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: DailyInspectionId.id },
  ],
  additionalCompatibleTemplateItems: inspections,
})

export const PunchList = new DailyInspectionReportItem({
  id: '117DBAE5-F3D7-40ED-97F4-B706557951FC',
  name: 'Punch List',
  classType: 'DailyInspectionPunchList',
  classTypeName: 'Punch List',
  endpoint: 'punchLists',
  queryParameter: 'punch-list',
  label: 'punchListId',
  sampleFilename: 'punch-list',
  afterShortName: [
    { type: 'custom', text: '_PUNCH-LIST_' },
    { type: 'templateItem', templateItemId: DailyPunchListDate.id },
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: DailyPunchListId.id },
  ],
  additionalCompatibleTemplateItems: punchLists,
})

export type DailyInspectionReport =
  | typeof ControlPoint
  | typeof Inspection
  | typeof PunchList
